/*
 * This file is part of the Sylius package.
 *
 * (c) Paweł Jędrzejewski
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

(function ( $ ) {
    'use strict';

    $.fn.extend({
        removeFromCart: function () {
            $.each($(this), function (index, element) {
                var redirectUrl = $(element).data('redirect');
                var csrfToken = $(element).data('csrf-token');
                var dataUrl = $(element).data('url');

                $(this).on('click', function() {
                    $.ajax({
                        url: dataUrl,
                        method: 'POST',
                        data: { _csrf_token : csrfToken, _method: 'DELETE' },
                        success: function (response) {
                            window.location.replace(redirectUrl);
                        }
                    });
                });
            });
        },
        addToCart: function () {
            var element = $(this);
            var href = $(element).attr('action');
            var redirectUrl = $(element).data('redirect');
            var validationElement = $(this).find('#sylius-cart-validation-error');

            $(this).on('submit', function(e) {

                $.ajax({
                    method: 'POST',
                    url: href,
                    cache: false,
                    data: $(this).serialize(),
                    success: function (response) {
                        validationElement.addClass('hidden');
                        validationElement.removeClass('mb-15');
                        if (window.location.href.indexOf(redirectUrl) > -1) {
                            window.location.replace(redirectUrl);
                        }
                        else {
                            $('.add-product-modal').modal('show');
                        }
                    },
                    error: function(response) {
                        response = response.responseJSON;
                        validationElement.removeClass('hidden');
                        var validationMessage = '';

                        $.each(response.errors.errors, function (key, message) {
                            validationMessage += message;
                        });
                        validationElement.addClass('mb-15');
                        validationElement.html('<i class="fa fa-warning"></i> &nbsp;' + validationMessage);
                        $(element).removeClass('loading');
                    }
                });
                e.preventDefault();
            });
        }
    });

})( jQuery );


(function($) {
    $(document).ready(function () {
        $('.sylius-cart-remove-button').removeFromCart();
        $('#sylius-product-adding-to-cart').addToCart();
    });
})(jQuery);
